import {
  ButtonIcon,
  IconX,
  IconPlusAltActive,
} from '@spotify-internal/encore-web';
import { FieldInput } from 'components/encore/form/Field';
import { css } from 'emotion';
import { PollFormData } from 'modules/AnchorAPI/v3/episodes/fetchInteractivityPoll';
import React from 'react';
import {
  Control,
  FieldErrors,
  useFieldArray,
  UseFormRegister,
} from 'react-hook-form';
import {
  OptionsContainer,
  OptionsInputsGridContainer,
  StyledFieldLabel,
} from '../InteractivePoll/styles';

export function OptionsFieldArray({
  control,
  register,
  errors,
}: {
  control: Control<PollFormData>;
  register: UseFormRegister<PollFormData>;
  errors?: FieldErrors;
}) {
  const { fields, append, remove } = useFieldArray<PollFormData>({
    name: 'options',
    control,
  });

  return (
    <OptionsContainer>
      <StyledFieldLabel htmlFor="options">Poll choices</StyledFieldLabel>
      <p
        className={css`
          margin-bottom: 1.6rem;
        `}
      >
        You&apos;ll need at least 2 choices and a maximum of 7 to publish a
        poll.
      </p>
      <OptionsInputsGridContainer>
        <div>
          {fields.map((option, i) => {
            const error = errors?.options && errors.options[i]?.description;
            return (
              <div
                key={`${option.id}`}
                className={css`
                  margin-bottom: 1.6rem;
                  width: 100%;
                  display: flex;
                  align-items: center;
                `}
              >
                <FieldInput
                  error={error}
                  containerClassName={css`
                    flex: 1;
                  `}
                  type="text"
                  placeholder={`option #${i + 1}`}
                  {...register(`options.${i}.description`, {
                    required: 'Required',
                  })}
                />
                <ButtonIcon
                  onClick={() => remove(i)}
                  disabled={fields.length <= 2}
                  className={css`
                    margin-left: 8px;
                  `}
                >
                  <IconX
                    aria-label={
                      option.description
                        ? `Remove "${option.description}" option`
                        : 'Remove option row'
                    }
                  />
                </ButtonIcon>
              </div>
            );
          })}
        </div>
      </OptionsInputsGridContainer>
      {fields.length < 7 && (
        <ButtonIcon
          onClick={() => append({ description: '' })}
          semanticColor="textBrightAccent"
          className={css`
            display: flex;
            align-items: center;
          `}
        >
          <IconPlusAltActive
            className={css`
              margin-right: 8px;
            `}
          />
          Add option
        </ButtonIcon>
      )}
    </OptionsContainer>
  );
}
